import { I18N_DEFAULT_NS } from '../types.js';
export const getNamespace = (instance) => {
    const namespace = Array.isArray(instance.options.ns)
        ? instance.options.ns[0]
        : instance.options.ns;
    return namespace || I18N_DEFAULT_NS;
};
//# sourceMappingURL=getNamespace.js.map